document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-tabs-group]').forEach(function (wrap) {
    var buttons = wrap.querySelectorAll('[data-tab-btn]');
    var panels = wrap.querySelectorAll('[data-tab-panel]');

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var target = btn.getAttribute('data-tab-btn');

        buttons.forEach(function (b) { b.classList.remove('is-active'); });
        panels.forEach(function (p) { p.classList.remove('is-active'); });

        btn.classList.add('is-active');
        var panel = wrap.querySelector('[data-tab-panel="' + target + '"]');
        if (panel) panel.classList.add('is-active');
      });
    });
  });
});